import {
    FieldInCard,
} from 'app/types/form.types'
import {
    ContractCurrency, FxRateType,
} from 'app/enums/label.enums'

import {
    FxRateFields,
} from './FxRate.types'

const fields = (getAllowedValues): FieldInCard<FxRateFields>[] => {
    return [{
        id: 'fxRate',
        title: 'FX Rate',
        className: 'fxRate',
        fields: [
            {
                name: 'ccyFrom',
                useDropdown: true,
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(ContractCurrency),
                required: true,
                labelKey: 'CURRENCY_FROM',
            },
            {
                name: 'exchangeRate',
                className: 'exchangeRate',
                required: true,
                componentName: 'IntegerInput',
                labelKey: 'FX_RATE',
            },
            {
                name: 'fxRateType',
                useDropdown: true,
                className: 'fxRateType',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(FxRateType),
                required: true,
                labelKey: 'FX_RATE_TYPE',
            },
            {
                name: 'validFrom',
                componentName: 'DateSelect',
                required: true,
                labelKey: 'VALID_FROM',
            },
            {
                name: 'ccyTo',
                useDropdown: true,
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(ContractCurrency),
                required: true,
                labelKey: 'CURRENCY_TO',
            },
            {
                name: 'validTo',
                componentName: 'DateSelect',
                required: true,
                labelKey: 'VALID_TO',
            },
        ],
    }]
}

export default fields
